var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-area"},[_c('div',{staticClass:"logo-social"},[_c('div',[_vm._v("Apoio")]),_c('img',{staticClass:"social",attrs:{"src":_vm.getImgUrl('criancaesperanca.png'),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }